import * as React from "react";
const SvgCheckmarkSlot = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 7.5, fill: "white", fillOpacity: 0.5, stroke: "#595959" }));
export default SvgCheckmarkSlot;
